
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gVuyEthuCFw7chxMI5kX2EcUG6yeFmAwZGtOI3yg2MWYMeta } from "/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index3xKzYd2Qv7Intb7bOtkKUGIAvGi_o0PPasV_NiGr1qgMeta } from "/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchTRD4B0hqW0ZmdzbCylLapR7I5KxbRNkfgt2jMwrRmWwMeta } from "/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexBeKxaZ0_45o5CFxb1OMLq9L3qrdbTsTjPhOXaIiOnjCQkMeta } from "/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_9324LfEGG_1r5saWN3mk_45qUUsehhttulk6ios_D0UC0csMeta } from "/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexXdvnCILpykJwESeegDyxrj3Xap8Ism1SCrEN0XhWvsUMeta } from "/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93OTMClz9vdEYZgogH632db_3vE5YYL11JmcKvNyouQ9QMeta } from "/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexxHkVxxm_qYBC5LJYEXVk7tFR_459m_45wRxl5nubPweq70UMeta } from "/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93WfoZB2YDj6kIsLjCiRxt_KvkgQZ_10nHWrgt9pN8uagMeta } from "/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexpIH_TV_45A9qoSTNpNlcv4WYi9OSVSjDXOzH97DOADwoYMeta } from "/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index1jskuAQUwgyNOOXThPi8G3PDm3Vyr0YS2V9or9A9KZEMeta } from "/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexXdvnCILpykJwESeegDyxrj3Xap8Ism1SCrEN0XhWvsUMeta || {},
    component: () => import("/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexxHkVxxm_qYBC5LJYEXVk7tFR_459m_45wRxl5nubPweq70UMeta || {},
    component: () => import("/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexpIH_TV_45A9qoSTNpNlcv4WYi9OSVSjDXOzH97DOADwoYMeta || {},
    component: () => import("/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index1jskuAQUwgyNOOXThPi8G3PDm3Vyr0YS2V9or9A9KZEMeta || {},
    component: () => import("/codebuild/output/src3411674162/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]